import React from 'react';
import { SectionLabel } from './ui/SectionLabel';
const questions = ['What am I teaching tomorrow?', 'How do I make this class different from the last one?', 'Which sequence makes sense for this group?', 'What transitions should I use?'];
export function ProblemSection() {
  return <section className="w-full bg-ivory py-9 sm:py-12" aria-labelledby="problem-heading" data-id="element-151" data-mp="2vpzaoowh01fa">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-152" data-mp="39hmbn21cxy4e">
        <div className="mx-auto max-w-2xl text-center" data-id="element-153" data-mp="39jyzfvtsr2pd">
          <div className="flex justify-center" data-id="element-154" data-mp="35f954besdw6k">
            <SectionLabel data-id="element-155" data-mp="35in5je3w3vbd">The reality</SectionLabel>
          </div>
          <h2 id="problem-heading" className="mt-3 font-serif text-[1.5rem] font-semibold uppercase leading-[1.1] text-ink sm:text-4xl" data-id="element-156" data-mp="3jfjwdfk0dcs9">
            Does this sound familiar?
          </h2>
        </div>

        <ul className="mx-auto mt-5 grid max-w-3xl grid-cols-2 gap-2" data-id="element-157" data-mp="1k2xxav97i63q">
          {questions.map(question => <li key={question} className="flex h-full items-center justify-center rounded-xl border border-sandDark bg-cream/70 px-3 py-3 text-center font-serif text-[0.8rem] italic leading-snug text-muted sm:text-[0.95rem]" data-id="element-158" data-mp="jddbm61f48uh">
              “{question}”
            </li>)}
        </ul>

        <p className="mx-auto mt-5 max-w-xl text-center text-[0.92rem] leading-relaxed text-muted sm:text-lg" data-id="element-159" data-mp="x5bg23k6pgkb">
          You already know how to teach yoga.
          <span className="mt-1 block font-semibold text-ink" data-id="element-160" data-mp="172fv7jfm4brm">
            The problem is having to keep creating the classes.
          </span>
        </p>
      </div>
    </section>;
}